import { connect } from 'react-redux'
import activityContentSelector from './activityContentSelector'
import ActivityContent from './ActivityContent'

export default connect(
  activityContentSelector,
  {}
)(ActivityContent)
